import { render, staticRenderFns } from "./CustomerTrainingResources.vue?vue&type=template&id=32d273b8&"
import script from "./CustomerTrainingResources.vue?vue&type=script&lang=js&"
export * from "./CustomerTrainingResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports